import React, { useState } from 'react'
import { deletePlanAccountAction } from 'src/redux/actions/planAction'
import { useDispatch } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import {
  GeneralPlanInfoWrapper,
  PlanWithdrawBtnWrapper,
  PlanNameContainer,
  AmountAndProgressWrapper,
  PlanDetails,
  MorePlanOptions,
} from './styles'
import {
  PlanPrimaryBtn,
  PlanTopUpBtnSm,
  PlanTopUpBtnLg,
  PlanTransparentBtn,
  PlanDeleteBtn,
} from 'src/components/Global/Button/Button'
import { addNairaSign } from 'src/utils/addNairaSign'
import { UserCanWithdrawWrapper } from './styles'

const GeneralPlanInfo = ({ plan }: any) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const params = useParams()
  const { id } = params

  const {
    name,
    balance,
    can_withdraw,
    can_delete,
    start_date,
    maturity_date,
    saving_frequency,
    progress,
  } = plan

  console.log('hello')

  const deleteItem = () => {
    // console.log(id)
    dispatch(deletePlanAccountAction(id))
    navigate(-1)
  }
  console.log(name)

  return (
    <GeneralPlanInfoWrapper>
      <PlanWithdrawBtnWrapper>
        {can_withdraw ? (
          <PlanPrimaryBtn>Withdraw</PlanPrimaryBtn>
        ) : (
          <p>hello</p>
        )}
      </PlanWithdrawBtnWrapper>

      <PlanNameContainer>
        <h4 className="plan_name">{name}</h4>
      </PlanNameContainer>

      <AmountAndProgressWrapper>
        <p>{addNairaSign(balance)} saved</p>
        <p> {`${progress} days`}</p>
      </AmountAndProgressWrapper>

      <UserCanWithdrawWrapper>
        {can_withdraw ? (
          <div className="btn-flex">
            <PlanTopUpBtnSm>Top up</PlanTopUpBtnSm>

            <PlanTransparentBtn>Extend end Date</PlanTransparentBtn>
          </div>
        ) : (
          <PlanTopUpBtnLg>Top up</PlanTopUpBtnLg>
        )}
      </UserCanWithdrawWrapper>

      <PlanDetails>
        <div className="amount">
          <p>Amount being saved</p>
          <p>{addNairaSign(balance)}</p>
        </div>
        <div className="frequency">
          <p>Saving Frequency</p>
          <p>{saving_frequency}</p>
        </div>
        <div className="date">
          <p>End date</p>
          <p>{maturity_date}</p>
        </div>
      </PlanDetails>

      <MorePlanOptions>
        <div className="automate_savings"></div>
        <div className="start_date">
          <p>Start date</p>
          <p>{start_date}</p>
        </div>
        <div className="delete_option">
          {can_delete ? (
            <PlanDeleteBtn onClick={deleteItem}>Delete</PlanDeleteBtn>
          ) : null}
        </div>
      </MorePlanOptions>
    </GeneralPlanInfoWrapper>
  )
}

export default GeneralPlanInfo
